;(function ($) {

  "use strict";

  var Core = {

    DOMReady: function () {

      var self = this;

      self.searchBox();
      self.backToTopBtn({
        transitionIn: 'bounceInRight',
        transitionOut: 'bounceOutRight'
      });

      self.navigation.init();

    },

    windowLoad: function () {

      var self = this;

      self.fullScreen.init();
      self.progressBarsAnimation();

    },


    /**
     **  Full screen
     **/

    fullScreen: {

      init: function () {

        var self = this;

        self.w = $(window);
        self.header = $('#header');

        self.calculation();

        self.startAnimate();

        self.w.on('resize', function () {

          self.calculation();

        });

      },

      calculation: function () {

        var self = this;
        self.wHeight = self.w.height();

        // console.log(self.wHeight);

        $('.first_screen').height(self.wHeight);

      },

      startAnimate: function () {

        $('.first_screen').addClass('start_animate');
      }

    },


    /**
     **  Search Box
     **/

    searchBox: function () {

      $('.search_btn').on('click', function () {

        var $this = $(this);

        $this.parents('.search_box').toggleClass('active');
        $this.parents('.search_box').find('input[type="search"]').focus();

      });

      $(document).on('click', function (event) {

        if (!$(event.target).closest('.search_box').length) {
          $('.search_box').removeClass('active');
        }

      });

    },

    /**
     **  Back to top
     **/

    backToTopBtn: function (config) {

      config = $.extend({
        offset: 350,
        transitionIn: 'bounceInRight',
        transitionOut: 'bounceOutRight'
      }, config);

      var btn   = $('<button></button>', {
            class: 'back_to_top animated hidden',
            html: '<i class="fa fa-angle-up"></i>'
          }).appendTo($('body')),

          $wd   = $(window),
          $html = $('html'),
          $body = $('body');

      $wd.on('scroll.back_to_top', function () {

        if ($wd.scrollTop() > config.offset) {

          btn.removeClass('hidden ' + config.transitionOut).addClass(config.transitionIn);

        }
        else {

          btn.removeClass(config.transitionIn).addClass(config.transitionOut);

        }

      });

      btn.on('click', function () {

        $html.add($body).animate({

          scrollTop: 0

        });

      });

    },


    /**
     **  Main navigation
     **/

    navigation: {

      init: function () {

        var self = this;

        self.w = $(window);
        self.body = $('body');
        self.nav = $('.navigation');
        self.section = $('.section');
        self.sectionQt = self.section.length;

        self.anchorScroll();
        self.responsiveMenu.events();

        self.w.on('scroll', function () {

          self.pageScroll();

        });

        self.w.on('resize', function () {

          self.responsiveMenu.menuClose();

        });

      },

      anchorScroll: function () {

        /*	var self = this;

         self.nav.on('click', "a", function(event){

         event.preventDefault();

         var $this = $(this),
         item = $this.parent(),
         dataId = $this.attr('href'),
         offset = $(dataId).offset().top;


         item.addClass('current').siblings().removeClass('current');

         self.scrollContent(offset);

         });*/

      },

      scrollContent: function (offset) {

        var self = this;

        self.body.addClass('scrollContent');

        $('html,body').stop().animate({

          scrollTop: offset

        }, 1000, function () {

          self.body.removeClass('scrollContent');

        });

      },

      pageScroll: function () {

        var self = this;

        if (self.body.hasClass('scrollContent'))return;

        self.wScroll = self.w.scrollTop();
        self.wHeightHalf = self.w.height() / 2;

        for (var i = 0; i <= self.sectionQt - 1; i++) {

          var offset       = $(self.section[i]).offset().top,
              heightBox    = $(self.section[i]).outerHeight(),
              bottomOffset = $(self.section[i + 1]).length ? $(self.section[i + 1]).offset().top : offset + heightBox,
              id           = $(self.section[i]).attr('id'),
              activItem    = $('.navigation').find("a[href='" + "#" + id + "']").parent();

          $('.navigation li').removeClass('active');
          $('.navigation_point li').removeClass('navigation_point_active');

          if (self.wScroll + self.wHeightHalf > offset && self.wScroll + self.wHeightHalf < bottomOffset) {

            setTimeout(function () {

            }, 1000)

            activItem.addClass('current').siblings().removeClass('current');

            return false;

          }

        }
        ;

      },

      responsiveMenu: {

        events: function () {

          var self = this;

          self.nav = $('nav');
          self.navButton = $('.nav_btn');

          self.navButton.on('click', function () {

            if (self.nav.hasClass('open_menu')) {

              self.menuClose();

            }
            else {

              self.menuOpen();

            }

          });

          self.nav.on('click', 'a', function () {

            self.menuClose();

          });

        },

        menuOpen: function () {

          var self = this;

          self.nav.addClass('open_menu');

        },

        menuClose: function () {

          var self = this;

          self.nav.removeClass('open_menu');

        },

      },

    },


    /**
     **  ProgressBars
     **/

    progressBarsAnimation: function () {

      var progressBars = $('.progress_bars');

      if (!progressBars.length) return;

      var $wd = $(window),
          wh  = $wd.height() / 1.5;

      // reset values

      progressBars.find('.bar_title').attr('data-value', 0);

      progressBars.each(function () {

        var $this       = $(this),
            progressBar = $this.find('.progress_bar');

        progressBar.each(function (i, el) {

          $(el).find('.value_indicator').css($this.hasClass('vr') ? 'height' : 'width', 0);

        });

      });

      // bind scroll event

      $wd.on('scroll.progress_bars', function () {

        var scrollT = $wd.scrollTop();

        progressBars.each(function (i, container) {

          var $this       = $(this),
              progressBar = $this.find('.progress_bar');

          if (scrollT > $this.offset().top - wh && !$this.hasClass('animated')) {

            $this.addClass('animated');

            progressBar.each(function (i, el) {

              var $el       = $(el),
                  counter   = 0,
                  value     = $el.children('.bar_element').attr('data-value'),
                  title     = $el.find('.bar_title'),
                  indicator = $el.find('.value_indicator');

              var animation = setInterval(function () {

                title.attr('data-value', counter);

                indicator.css($this.hasClass('vr') ? 'height' : 'width', counter + '%');


                counter++;

                if (counter > value) clearInterval(animation);

              }, 10);

            });

          }

          if (i == progressBars.length - 1 && $(container).hasClass('animated')) $wd.off('.progress_bars');

        });

      });

      $wd.trigger('scroll.progress_bars');

    },


  }


  $(document).ready(function () {

    Core.DOMReady();

    /*******************************  CALCOLO RISPARMIO  ********************************/

    $('#calculate-saving-form').on('submit', function (event) {

      event.preventDefault();

      var method = $(this).attr('method');
      var action = $(this).attr('action');

      var data = $(this).serialize();
      var valuta = $(this).attr('data-valuta');

      $.ajax({
        url: action,
        type: method,
        dataType: 'json',
        data: data,
      })
        .success(function (data) {

          $('#results').empty();
          $('#errors').empty();

          if (data['possibile'] == true) {

            var separator = '<div class="divider"></div>';

            var consumo_annuo_gas = '<h3>' + data["str_consumo_gas"]
              + '<span class="pull-right">'
              + data["consumo_tot_gas"]
              + ' m³<small>/' + data["str_anno"] + '</small></span></h3>';

            var consumo_annuo_elettricita = '<h3>' + data["str_consumo_elettricita"]
              + '<span class="pull-right">'
              + data["consumo_tot_elettricita"]
              + ' kWh<small>/' + data["str_anno"] + '</small></span></h3>';

            var costo_tot_annuo = '<h3>' + data["str_costo_tot"]
              + '<span class="pull-right">'
              + data["costo_tot"]
              + ' '+valuta+'<small>/' + data["str_anno"] + '</small></span></h3>';

            var risparmio_annuo = '<h2>' + data["str_risparmio"]
              + '<span class="pull-right">'
              + data["risparmio"]
              + ' '+valuta+'<small>/' + data["str_anno"] + '</small></span></h2>';

            var download_pdf_button = '<div class="align_center">'
              + '<button type="submit" class="btn_type1 big darkblue">' + data["str_download"] + '</button>'
              + '</div>';

            var avviso = "<div class='align_center pt30'><small>" + data["str_avviso"] + "</small></div>";

            var csrf_token = '<input type="hidden" name="_token" value="' + $('meta[name="csrf-token"]').attr('content') + '">';

            var hidden_data = '<input type="hidden" name="data" value="' + data["all_data"] + '">';

            var hidden_locale = '<input type="hidden" name="locale" value="' + $('html').attr('lang') + '">';

            var hidden_valuta = '<input type="hidden" name="valuta" value="' + valuta + '">';

            $(separator).appendTo('#results');
            $(consumo_annuo_gas).appendTo('#results');
            $(consumo_annuo_elettricita).appendTo('#results');
            $(costo_tot_annuo).appendTo('#results');
            $(risparmio_annuo).appendTo('#results');
            $(download_pdf_button).appendTo('#results');
            $(avviso).appendTo('#results');
            $(csrf_token).appendTo('#results');
            $(hidden_data).appendTo('#results');
            $(hidden_locale).appendTo('#results');
            $(hidden_valuta).appendTo('#results');

            $('html,body').animate({scrollTop: $('#results').offset().top - 20}, 1000);

          } else {

            $('<div class="col-md-12"><div class="alert alert-danger" role="alert"></div></div>').appendTo('#errors');

            var avviso = '<p class="align_center"><i class="fa fa-exclamation-triangle"></i> ' + data["messaggio"] + '</p>';

            $(avviso).appendTo('#errors .alert');
          }

        })
        .fail(function (errors) {

          $('#results').empty();
          $('#errors').empty();

          $('<div class="col-md-12"><div class="alert alert-warning" role="alert"></div></div>').appendTo('#errors');

          $.each(errors.responseJSON, function (field, message) {

            var error = '<p><i class="fa fa-exclamation-triangle"></i> ' + message + '</p>';

            $(error).appendTo('#errors .alert');

          })

        })

    })

    /*******************************  /CALCOLO RISPARMIO  ********************************/

  });

  $(window).load(function () {

    Core.windowLoad();

  });

})(jQuery);